<div class="regras-simulador">

  <div class="po-row">
    <po-select
      class="po-md-3"
      p-label="Modo"
      [p-options]="modoOptions"
      [ngModel]="modo"
      (p-change)="modo = $event"
      [ngModelOptions]="{ standalone: true }"
      name="modo">
    </po-select>

    <small class="po-md-9 po-font-text-small regras-simulador__ajuda">
      Nada é gravado: a simulação apenas consulta os cadastros.
    </small>
  </div>

  <!-- ------------------------------------------------ modo nota hipotética -->
  <form *ngIf="modo === 'hipotetica'" [formGroup]="formCenario">

    <div class="po-row regras-simulador__pdf">
      <div class="po-md-12">
        <label class="regras-simulador__arquivo">
          <span class="po-icon an an-file-pdf"></span>
          {{ nomePdf || 'Preencher a partir de um PDF da nota' }}
          <input type="file" accept="application/pdf" (change)="lerPdf($event)" hidden>
        </label>
        <span *ngIf="lendoPdf" class="po-font-text-small">Lendo o documento…</span>
        <a *ngIf="nomePdf && !lendoPdf" class="regras-simulador__limpar" (click)="limparPdf()">Remover</a>
      </div>
    </div>

    <!-- O que o PDF nao respondeu: em vez de deixar o campo vazio sem
         explicacao, dizemos o que conferir antes de simular. -->
    <div class="po-row" *ngIf="avisosPdf.length">
      <ul class="po-md-12 regras-simulador__avisos">
        <li *ngFor="let aviso of avisosPdf">{{ aviso }}</li>
      </ul>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-3"
        p-label="Tipo de documento"
        [p-options]="tipoDocOptions"
        formControlName="tipoDoc"
        p-required>
      </po-select>

      <po-combo
        class="po-md-5"
        p-label="Filial da nota"
        p-filter-service="portalnf/regras/lookup/filial"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        [p-infinite-scroll]="true"
        name="filial"
        formControlName="filial"
        [p-required]="true">
      </po-combo>

      <po-select
        class="po-md-4"
        p-label="Tipo de processo"
        [p-options]="tipoProcOptions"
        formControlName="tipoProcesso">
      </po-select>
    </div>

    <div class="po-row">
      <po-select
        class="po-md-3"
        p-label="Gera financeiro"
        [p-options]="simNaoOptions"
        formControlName="geraFinanceiro">
      </po-select>

      <po-select
        class="po-md-3"
        p-label="Simples Nacional"
        [p-options]="simNaoOptions"
        formControlName="simplesNacional">
      </po-select>

      <po-select
        *ngIf="ehCte"
        class="po-md-3"
        p-label="Situação do ICMS"
        [p-options]="icmsOptions"
        p-help="Não informado reproduz o comportamento atual"
        formControlName="icmsIsento">
      </po-select>

      <po-select
        *ngIf="!ehCte"
        class="po-md-3"
        p-label="ISS retido"
        [p-options]="simNaoOptions"
        formControlName="issRetido">
      </po-select>

      <!-- Moeda como na inclusao manual: po-decimal com 2 casas no padrao
           pt-BR (141.698,53). O po-input com p-mask="9999999999.99" exibia
           o valor sem a virgula ("14169853"). -->
      <po-decimal
        class="po-md-3"
        p-label="Valor total do serviço (R$)"
        p-locale="pt"
        [p-decimals-length]="2"
        [p-min]="0"
        formControlName="valorTotal">
      </po-decimal>
    </div>

    <div class="po-row" *ngIf="ehCte">
      <po-input
        class="po-md-6"
        p-label="CNPJ do tomador"
        p-placeholder="Somente dígitos"
        formControlName="cnpjTomador">
      </po-input>
    </div>

    <div class="po-row" *ngIf="!ehCte">
      <po-input
        class="po-md-6"
        p-label="Código de serviço (LC 116)"
        p-placeholder="Ex.: 11.04"
        formControlName="cnae">
      </po-input>
    </div>

    <div class="po-row">
      <small class="po-md-12 po-font-text-small regras-simulador__secao">
        Retenções — definem a natureza financeira
      </small>
    </div>

    <div class="po-row">
      <po-decimal class="po-md-2" p-label="IRRF (R$)" p-locale="pt" [p-decimals-length]="2" [p-min]="0"
        formControlName="ir"></po-decimal>
      <po-decimal class="po-md-2" p-label="PIS (R$)" p-locale="pt" [p-decimals-length]="2" [p-min]="0"
        formControlName="pis"></po-decimal>
      <po-decimal class="po-md-2" p-label="COFINS (R$)" p-locale="pt" [p-decimals-length]="2" [p-min]="0"
        formControlName="cofins"></po-decimal>
      <po-decimal class="po-md-2" p-label="CSLL (R$)" p-locale="pt" [p-decimals-length]="2" [p-min]="0"
        formControlName="csll"></po-decimal>
      <po-decimal class="po-md-2" p-label="INSS (R$)" p-locale="pt" [p-decimals-length]="2" [p-min]="0"
        formControlName="inss"></po-decimal>

      <div class="po-md-2 regras-simulador__acao">
        <po-button p-label="Simular" p-kind="primary" [p-loading]="loading" (p-click)="simular()"></po-button>
      </div>
    </div>
  </form>

  <!-- ------------------------------------------------- modo nota lançada -->
  <form *ngIf="modo === 'nota'" [formGroup]="formNota">
    <div class="po-row">
      <po-combo
        class="po-md-4"
        p-label="Filial"
        p-filter-service="portalnf/regras/lookup/filial"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        [p-infinite-scroll]="true"
        name="filialNota"
        formControlName="filial"
        [p-required]="true">
      </po-combo>

      <po-input class="po-md-2" p-label="Número" formControlName="doc" p-required></po-input>
      <po-input class="po-md-2" p-label="Série" formControlName="serie"></po-input>
      <po-input class="po-md-2" p-label="Fornecedor" formControlName="fornecedor"></po-input>

      <div class="po-md-2 regras-simulador__acao">
        <po-button p-label="Reconstituir" p-kind="primary" [p-loading]="loading" (p-click)="simularNota()"></po-button>
      </div>
    </div>
  </form>

  <!-- ------------------------------------------------------- nota lançada -->
  <div class="po-row" *ngIf="resultadoNota as rn">
    <po-widget class="po-md-12" p-title="Nota">
      <div class="regras-simulador__nota">
        <span><b>{{ rn.nota.doc }}</b>/{{ rn.nota.serie }} &middot; filial {{ rn.nota.filial }}</span>
        <span>TES {{ rn.nota.tes || '—' }} &middot; natureza {{ rn.nota.natureza || '—' }}</span>
        <span>produto {{ rn.nota.produto || '—' }}</span>
      </div>

      <p *ngIf="!rn.temCenario" class="regras-simulador__aviso">
        {{ rn.aviso }} Use o modo <b>Nota hipotética</b> informando os atributos para descobrir
        qual regra se aplicaria hoje.
      </p>

      <div *ngIf="rn.temCenario" class="regras-simulador__comparacao">
        <div *ngFor="let c of comparacoes" class="regras-simulador__linha">
          <span class="regras-simulador__rotulo">{{ c.rotulo }}</span>
          <span>aplicada: <b>{{ aplicadaDe(c.chave)?.cod || '—' }}</b></span>
          <span>hoje: <b>{{ regraAtualDe(c.chave) || '—' }}</b></span>
          <span *ngIf="divergiu(c.chave)" class="regras-simulador__divergencia">
            regra alterada depois da entrega
          </span>
        </div>
      </div>
    </po-widget>
  </div>

  <!-- ---------------------------------------------------------- resultado -->
  <div class="po-row" *ngIf="cartoes.length">
    <po-widget *ngFor="let c of cartoes" class="po-md-6" [p-title]="c.titulo">

      <div class="regras-simulador__valor">{{ c.valor }}</div>

      <div *ngIf="c.decisao.regra as cod" class="regras-simulador__regra">
        <span>Regra <b>{{ cod }}</b></span>
        <span *ngFor="let p of c.decisao.rastro">
          <ng-container *ngIf="p.cod === cod && p.casou">
            &middot; ordem {{ p.ordem || '—' }} &middot; {{ vigenciaDe(p.vigIni, p.vigFim) }}
          </ng-container>
        </span>
        <a *ngIf="c.aba" class="regras-simulador__link" (click)="irParaRegra(c)">abrir no cadastro</a>
      </div>

      <p *ngIf="c.semCobertura" class="regras-simulador__sem-cobertura">{{ c.semCobertura }}</p>

      <details *ngIf="c.decisao.rastro.length" class="regras-simulador__rastro">
        <summary>Como o motor chegou aqui ({{ c.decisao.rastro.length }} regras avaliadas)</summary>
        <ul>
          <li *ngFor="let p of c.decisao.rastro" [class.casou]="p.casou">
            <b>{{ p.cod }}</b>
            <span *ngIf="p.ordem"> (ordem {{ p.ordem }})</span>
            <span *ngIf="p.casou"> — aplicada</span>
            <span *ngIf="!p.casou"> — {{ p.motivo }}</span>
          </li>
        </ul>
      </details>

    </po-widget>
  </div>

</div>
